(ns bp-libs.design-system.components.animations
  (:require [bp-libs.design-system.components.icons :refer [loading-spinner]]))

(defn rotating-spinner
  {:storybook {:size {:name         "Container Config"
                      :type         {:name "object"}
                      :defaultValue "30px"
                      :control      {:type "object"}}}}
  [props]
  (let [size (or (:size props) "30px")]
    [loading-spinner {:height size
                      :width size
                      :class "animate-rotate"}]))
